import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import { css } from 'glamor'

let container = css({
  '@import': 'https://fonts.googleapis.com/css?family=Lato|Roboto',
  background: '#171717',
  color: '#cfcfcf',
  margin: '0 auto',
  maxWidth: 960,
  minHeight: 600,
  paddingTop: 0,
})

const TemplateWrapper = ({ children }) => (
  <div style={{background: '#171717', minHeight: '100vh'}}>
    <Helmet
      title="voodoo down records, brooklyn, ny"
      meta={[
        { name: 'description', content: 'Record label for techno music based in Brooklyn, NY & Berlin, Germany' },
        { name: 'keywords', content: 'house, deep house, techno, underground electronic music, 12x12, n conduit, lestasi delloro' },
      ]}
    />
    <Header />
    <div className={container}>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js